/* global ol */
'use strict'

export default class PrairiesMapController {
  constructor () {
    this.internal = {
      uiElements: {
        olMap: null,
        toggleButton: null
      },
      config: {
        layerOpacity: 0.8
      }
    }
  }

  load () {
    if ($('#prairies-container').length > 0) {
      this.initMap()
    }
  }

  initMap () {
    const left = 739500 // 741500.73380 // 749900.7338000000454485
    const bottom = 5752170// 5752470.57799 // 5752472.5779999997466803
    const right = 793960// 792360.23519 // 784602.2351999999955297
    const top = 5793613 // 5793613.34690 // 5791324.3469000002369285
    // const extent = ol.proj.transformExtent([east, north, west, south], 'EPSG:4326', 'EPSG:3857')

    const imageLayer = new ol.layer.Image({
      properties: { title: 'image-layer' },
      opacity: 1, // this.internal.config.layerOpacity,
      source: new ol.source.ImageStatic({
        interpolate: false,
        url: window.location.origin + '/img/map/prairies/Layer0.png',
        // projection: new ol.proj.Projection({
        //   units: 'pixels',
        //   extent: [bottomLeft, bottomRight, topLeft, topRight]
        // }),
        // This is the [left, bottom, right, top] map coordinates of your image.
        imageExtent: [left, bottom, right, top]
      })
    })

    this.internal.uiElements.toggleButton = $('#toggle-layer')

    const that = this
    this.internal.uiElements.toggleButton.on('click', function (e) {
      that.onToggleLayer(e.target.checked)
    })

    this.internal.uiElements.olMap = new ol.Map({
      target: 'prairies-map',
      pixelRatio: 1,
      view: new ol.View({
        center: ol.proj.fromLonLat([6.88, 45.97]),
        zoom: 13,
        maxZoom: 19
      }),
      controls: [
        new ol.control.ScaleLine()
      ],
      layers: [
        new ol.layer.Tile({
          preload: 3,
          source: new ol.source.OSM({
            crossOrigin: null,
            url: 'https://tile.thunderforest.com/landscape/{z}/{x}/{y}.png?apikey=851c476fad9743cca9b16af9c72ecc05'
          })
        }),
        imageLayer
      ],
      loadTilesWhileAnimating: true
    })
  }

  onToggleLayer (isShown) {
    const layer = this.internal.uiElements.olMap.getAllLayers().find(layer => layer.get('title') === 'image-layer')
    if (layer) {
      layer.setOpacity(isShown ? this.internal.config.layerOpacity : 0)
    }
  }
}
